// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"a0cba98d","81":"267b937c","358":"02707e10","479":"c28764cb","645":"d765f082","781":"a77bffb1","869":"d5344a24","900":"8fd715c3","928":"61cf1481","953":"c82b0e0a","956":"77505507"}[chunkId] + ".chunk.js";
};